import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, ThemeProvider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import { portalTheme } from '@mcn-platform/converse-lib';
// import LoadGuard from 'components/adminLayout/LoadGuard';
// import GlobalStyles from 'components/GlobalStyles';
import Microcast from './Microcast';
import AppBar from '../nav/AppBar';
import FooterBar from '../nav/FooterBar';
const MicrocastPage = () => {
    const { status } = useStore();
    const { keyOrID } = useParams();
    if (status !== 'ready') {
        return null;
    }
    return (_jsx(ThemeProvider, { theme: portalTheme, children: _jsxs(Box, { children: [_jsx(AppBar, {}), _jsx(Microcast, { microcastID: keyOrID }), _jsx(FooterBar, {})] }) }));
};
export default observer(MicrocastPage);
//# sourceMappingURL=MicrocastPage.js.map